export default function monthName(month: number, locale = "cs-CZ") {
  const formatter = new Intl.DateTimeFormat(locale, { month: "long" });
  return formatter.format(new Date(2021, month - 1, 1));
}
